import { Activity, ShieldCheck } from 'lucide-react';
import { CoverageSummary } from '@/components/knowledge/quality/CoverageSummary';
import { CoverageTrendSparkline } from '@/components/knowledge/quality/CoverageTrendSparkline';
import { ConfidenceHistogram } from '@/components/knowledge/quality/ConfidenceHistogram';
import { MergeSignalsPanel } from '@/components/knowledge/quality/MergeSignalsPanel';
import { ThresholdRecommendationsPanel } from '@/components/knowledge/quality/ThresholdRecommendationsPanel';

export function QualityDashboardPage() {
  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
        <div className="flex items-center gap-2">
          <ShieldCheck size={18} className="text-brand-teal" />
          <div>
            <h1 className="text-xl font-semibold text-navy-900">Quality Dashboard</h1>
            <p className="text-sm text-slate-500 mt-0.5">
              Resolution quality signals, merge anomalies, and closed-loop threshold
              tuning
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1 text-[10px] text-slate-400 font-mono">
          <Activity size={11} />
          <span>Phase 4 — closed-loop governance</span>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6 space-y-6">
        <CoverageSummary />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <CoverageTrendSparkline />
          <ConfidenceHistogram />
        </div>
        <MergeSignalsPanel />
        <ThresholdRecommendationsPanel />
      </div>
    </div>
  );
}
